import { put } from 'api/put';
import { get } from 'api/get';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const IMPORTER_STATS_REQUEST = 'importerStats/actions/request';
export const IMPORTER_STATS_SUCCESS = 'importerStats/actions/success';
export const IMPORTER_STATS_FAILURE = 'importerStats/actions/failure';
export const IMPORTER_STATS_UPDATE_LOG = 'importerStats/actions/update-log';

export const SYNC_REQUEST = 'importer/sync/request';
export const SYNC_SUCCESS = 'importer/sync/success';
export const SYNC_FAILURE = 'importer/sync/failure';

export const BULK_SYNC_REQUEST = 'importer/bulk-sync/request';
export const BULK_SYNC_SUCCESS = 'importer/bulk-sync/success';

export function startSync( productGroupID ) {
  return async (dispatch) => {

    dispatch({
      type: SYNC_REQUEST,
      payload: {
        productGroupID: productGroupID
      }
    });

    try {

      await put('import/product', {
        pgid: productGroupID
      });
      
      dispatch({
        type: SYNC_SUCCESS,
        payload: {
          productGroupID: productGroupID
        }
      });
      dispatch(appendStatus('Product synced successfully.', 'info'));
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SYNC_FAILURE,
        payload: {
          productGroupID: productGroupID
        }
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function startBulkSync (ids, key) {
  return async (dispatch) => {

    _.each(ids, (id) => {
      dispatch({
        type: SYNC_REQUEST,
        payload: {
          productGroupID: id
        }
      });
    });

    dispatch({
      type: BULK_SYNC_REQUEST,
      payload: ids
    });

    try {
      await put('import/products', {
        pgids: ids,
        key: key
      });
      
      dispatch(appendStatus('Bulk products sync started.', 'info'));
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SYNC_FAILURE,
        payload: {
          productGroupID: productGroupID
        }
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function finishBulkSync () {
  return async (dispatch, getState) => {
    
    let ids = getState().importerStats.bulkSyncIDs;
    
    _.each(ids, (id) => {
      dispatch({
        type: SYNC_SUCCESS,
        payload: {
          productGroupID: id
        }
      });
    });

    dispatch({
      type: BULK_SYNC_SUCCESS,
      payload: null
    });

    dispatch(appendStatus('Products synced successfully.', 'info'));
  }
}

// getImporterStats will get the statistics and misc. data of the importers from the db.
export function getImporterStats() {

  return async (dispatch) => {

    dispatch({
      type: IMPORTER_STATS_REQUEST,
      payload: null
    });

    try {

      const req = await get('importer-stats');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: IMPORTER_STATS_SUCCESS,
        payload: data
      });
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: IMPORTER_STATS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function updateImportLog(payload) {
  return {
    type: IMPORTER_STATS_UPDATE_LOG,
    payload: payload,
  }
}

